const create = config => {
  const { debug } = config;

  const log = options => {
    const { level, message } = options;

    if (debug || level === 'error') {
      console[level](message); // eslint-disable-line no-console
    }
  };

  const fn = level => message =>
    log({
      level,
      message,
    });

  const info = fn('info');
  const warn = fn('warn');
  const error = fn('error');

  return {
    log,
    info,
    warn,
    error,
  };
};

export { create };
